export const normalizeKey = (key: string) => key.toLowerCase().replace(/[^0-9a-z.]/gi, '')
